import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/app";
import { AppErrorBoundary } from "./app/error_boundary";
import { ThemeProvider } from "./app/theme_provider";
import { TooltipProvider } from "./components/icon_button";
import { installLocalOnlyFontFace } from "./editor/font_network_boundary";
import "./styles/global.css";

const rootElement = document.getElementById("root");

// Excalidraw resolves every bundled font from Shotboard's static origin.
window.EXCALIDRAW_ASSET_PATH = "/excalidraw_assets/";
installLocalOnlyFontFace();

// Development and test builds expose bounded diagnostics without shipping telemetry.
if (import.meta.env.DEV || import.meta.env.MODE === "test") {
  void import("./performance/long_task_instrumentation").then(
    ({ installLongTaskInstrumentation }) => installLongTaskInstrumentation(),
  );
}

if (rootElement === null) {
  throw new Error("Shotboard could not find its application root.");
}

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <TooltipProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </TooltipProvider>
    </AppErrorBoundary>
  </StrictMode>,
);
